<template>
  <div class="qty-wrapper">
    <div class="qty-fields">
      <SfQuantitySelector
        class="a-product-quantity"
        :qty="localQuantity"
        :value="localQuantity"
        :min="1"
        :max="maxQuantity"
        step="1"
        :disabled="disabled"
        @input="updateQuantity"
        @blur="$v.$touch()"
      />
      <span>
        <span class="qty-label">
          {{ basePriceLabel('vk_einheit') }}
        </span>
      </span>

      <span class="equals-symbol">=</span>

      <SfQuantitySelector
        class="a-product-quantity"
        :qty="baseValue"
        :value="baseValue"
        :min="1"
        :max="maxQuantity ? maxQuantity * product.baseprice_product_amount : ''"
        :disabled="disabled"
        @input="enterBaseQuantity"
        @blur="$v.$touch()"
      />
      <span class="base-price-label">{{ basePriceLabel('baseprice_product_unit') }}</span>
    </div>

    <div
      v-if="showOffcuts"
      class="qty-offcuts"
    >
      <SfCheckbox
        label="+10% Verschnitt"
        name="offcutscheckbox"
        v-model="offcuts"
        @change="updateOffcuts"
      />
    </div>
  </div>
</template>

<script>
import AProductQuantity from 'theme/components/atoms/a-product-quantity'
import { optionLabel } from '@vue-storefront/core/modules/catalog/helpers';
import { SfCheckbox } from '@storefront-ui/vue';

export default {
  name: 'AProductQuantityCalculator',
  mixins: [
    AProductQuantity
  ],
  components: {
    SfCheckbox
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    },
    value: {
      type: [Number, String],
      default: 1
    },
    maxQuantity: {
      type: Number,
      default: 1000
    },
    loading: {
      type: Boolean,
      default: false
    },
    unlimitQuantity: {
      type: Boolean,
      default: false
    },
    showOffcuts: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localQuantity: 1,
      baseValue: 1,
      offcuts: false,
      beforeOffcut: 0
    };
  },
  created () {
    this.updateQuantity(this.value)
  },
  watch: {
    value (newValue) {
      if (parseFloat(newValue) !== this.localQuantity) {
        this.updateQuantity(newValue)
      }
    }
  },
  methods: {
    updateOffcuts () {
      let value = this.baseValue
      if (this.offcuts) {
        this.beforeOffcut = value
        value = this.formatAreaValue(parseFloat(value) * 1.1)
      } else {
        value = this.formatAreaValue(this.beforeOffcut)
      }
      this.updateBaseQuantity(value)
    },
    resetOffcuts () {
      this.offcuts = false
    },
    enterBaseQuantity (value) {
      if (this.showOffcuts) {
        this.resetOffcuts()
      }
      this.updateBaseQuantity(value)
    },
    formatAreaValue (value) {
      const amount = parseFloat(value)
      if (isNaN(amount)) return '1.000'
      return amount.toFixed(3)
    },
    updateBaseQuantity (value) {
      const newValue = parseFloat(value)
      this.baseValue = this.formatAreaValue(!isNaN(newValue) ? newValue : 1)

      let quantity = 1
      if (!isNaN(newValue)) {
        quantity = Math.ceil(newValue / this.product.baseprice_product_amount)
        if (quantity === 0) {
          quantity = 1
        }
      }

      this.localQuantity = quantity
      this.$emit('input', this.localQuantity)
    },
    updateQuantity (value) {
      if (this.showOffcuts) {
        this.resetOffcuts()
      }
      const roundedValue = !isNaN(value) && value > 1 ? Math.ceil(value) : 1
      this.localQuantity = roundedValue
      this.baseValue = this.formatAreaValue(roundedValue * this.product.baseprice_product_amount)
      this.$emit('input', this.localQuantity)
    },
    basePriceLabel (attr) {
      let product = this.product;
      if (this.$store.state.product.current.type_id === 'bundle') {
        product = this.$store.state.product.current
      }
      return optionLabel(
        this.$store.state.attribute,
        { attributeKey: attr, optionId: product[attr] }
      )
    }
  }
};
</script>
